import { Node } from "reactflow";
import { enqueueSnackbar } from "notistack";    
//

const checarSeNoExiste = (nodes: Node[], type: string) => {
    return nodes.some(node => node.type === type);
};

export const verificacaoDropItemNoQuadro = (item: any, nodes: Node[]): boolean => {
    const verificarNoInicio = checarSeNoExiste(nodes, "Início")
    const verificarNoFinal = checarSeNoExiste(nodes, "Fim")

    if (item.type === "Início" && verificarNoInicio) {
        enqueueSnackbar("Nó de 'Início' já existe dentro do fluxo!", { variant: "warning" })
        return true
    }
    if (item.type === "Fim" && verificarNoFinal) {
        enqueueSnackbar("Nó de 'Fim' já existe dentro do fluxo!", { variant: "warning" })
        return true
    }

    return false
}

//



//